import React from 'react'
import './Block.scss'
import {useStaticQuery, graphql} from 'gatsby'
import Facts from '../Facts/Facts'
import Menu from '../Menu/Menu'
import InfoBoxes from '../InfoBoxes/InfoBoxes'
import Illustration from '../Illustration/Illustration'
import Slideshow from '../Slideshow/Slideshow'

export default ({illustration, title, content, facts, infoBoxes, id, blocks, i}) => {

	const data = useStaticQuery(graphql`
		query slidesQuery {
			hydro: file(relativePath: {eq: "img/energy-sources/hydromountain.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			oil: file(relativePath: {eq: "img/energy-sources/rig.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			wind: file(relativePath: {eq: "img/energy-sources/windmills.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			smr: file(relativePath: {eq: "img/production/SMR.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			local: file(relativePath: {eq: "img/production/local.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			trucks: file(relativePath: {eq: "img/distribution/trucks.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			cargo: file(relativePath: {eq: "img/distribution/cargo.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			large: file(relativePath: {eq: "img/end-users/large-scale.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
			small: file(relativePath: {eq: "img/end-users/small-scale.png"}) {
				childImageSharp {
					fluid(quality: 100, maxWidth: 2000) {
						...GatsbyImageSharpFluid
					}
				}
			}
		}
	`)

	const slidesList = {
		energySources: [
			{
				title: 'Hydro-, solar- and windpower',
				image: data.hydro
			},
			{
				title: 'Natural gas',
				image: data.oil
			},
			{
				title: 'Wind energy',
				image: data.wind
			}
		],
		production: [
			{
				title: 'Centralised production',
				image: data.smr
			},
			{
				title: 'Local production',
				image: data.local
			}
		],
		distribution: [
			{
				title: 'Trucks',
				image: data.trucks
			},
			{
				title: 'Cargo',
				image: data.cargo
			}
		],
		endUsers: [
			{
				title: 'Large scale',
				image: data.large
			},
			{
				title: 'Small scale',
				image: data.small
			}
		]
	}

	const renderIllustration = () => {
		switch(illustration) {
			case 'energy-sources': {
				return <Slideshow slides={slidesList.energySources} />
			}
			case 'production': {
				return <Slideshow slides={slidesList.production} />
			}
			case 'processing': {
				return <Illustration source="processing" />
			}
			case 'distribution': {
				return <Slideshow slides={slidesList.distribution} />
			}
			case 'storage': {
				return <Illustration source="storage" />
			}
			case 'endusers': {
				return <Slideshow slides={slidesList.endUsers} />
			}
			default: {
				return null
			}
		}
	}

	return(
		<section className="Block" id={id}>

			<div className="content grid">
				<div className="menu">
					<Menu blocks={blocks} current={i} />
				</div>
				<div className="text">
					<h2>{title}</h2>
					<div className="text-inner" dangerouslySetInnerHTML={{__html: content}} />
					{ facts && <Facts facts={facts} /> }
				</div>
			</div>

			{ renderIllustration() }

			{ infoBoxes && <InfoBoxes boxes={infoBoxes} /> }

		</section>
	)
}